import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
// import ButtonBasic from '@/components/form/ButtonBasic.vue';
// import ToggleComponent from '@/components/form/ToggleComponent.vue';
//   import { ref } from 'vue';
var CryptoJS = require("crypto-js");
import axios from 'axios';
export default {
  name: 'UserRegistrationPurple',
  components: {
    // ButtonBasic,
    // ToggleComponent,
  },
  mounted: function mounted() {
    console.log('<<<<<<<<< UserRegistrationPurple mounted >>>>>>>>>');
    this.$store.commit('updateHideBluetoothController', true);
    if (localStorage.getItem('invalidEmail')) {
      this.hasInvalidEmail = true;
      this.invalidEmail = localStorage.getItem('invalidEmail');
      localStorage.removeItem('invalidEmail');
    }
  },
  methods: {
    showLoginPage: function showLoginPage() {
      console.log('show login');
      this.$store.commit('updateShowUserLoginBlue', true);
    },
    storageAvailable: function storageAvailable(type) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var storage, x;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              storage = window[type];
              x = '__storage_test__';
              storage.setItem(x, x);
              storage.removeItem(x);
              return _context.abrupt("return", true);
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", _context.t0 instanceof DOMException && (
              // everything except Firefox
              _context.t0.code === 22 ||
              // Firefox
              _context.t0.code === 1014 ||
              // test name field too, because code might not be present
              // everything except Firefox
              _context.t0.name === 'QuotaExceededError' ||
              // Firefox
              _context.t0.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
              // acknowledge QuotaExceededError only if there's something already stored
              storage && storage.length !== 0);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }))();
    },
    storeToken: function storeToken(token) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.storageAvailable('localStorage')) {
                console.log('storing token');
                localStorage.setItem('security', token);
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    encryptDetailsForTransit: function encryptDetailsForTransit(email, passwordIncoming) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var password, intransitPassword, intransitEmail;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              password = passwordIncoming + '!!!!@!!!!';
              intransitPassword = CryptoJS.AES.encrypt(password, '345678dfs90@#$%^&3456@34567*@#$567WERT3456&34567*#$%^&*34%^&*345^&#$%^&*ewrty#$%^&*dfgh#$%^&* ').toString();
              intransitEmail = CryptoJS.AES.encrypt(email, '345678dfs90@#$%^&3456@34567*@#$567WERT3456&34567*#$%^&*34%^&*345^&#$%^&*ewrty#$%^&*dfgh#$%^&* ').toString();
              return _context3.abrupt("return", {
                intransitEmail: intransitEmail,
                intransitPassword: intransitPassword
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    validateEmailFormat: function validateEmailFormat() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var email, emailRegex, emailEndsIn;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              email = _this2.email;
              emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // make sure the email also ends in .net, .com, .org, or .edu or .gov or .mil or .int or .arpa or .co
              emailEndsIn = email.split('.').pop();
              if (!(emailEndsIn !== 'com' && emailEndsIn !== 'net' && emailEndsIn !== 'org' && emailEndsIn !== 'edu' && emailEndsIn !== 'gov' && emailEndsIn !== 'mil' && emailEndsIn !== 'int' && emailEndsIn !== 'arpa' && emailEndsIn !== 'co')) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return", false);
            case 5:
              if (!emailRegex.test(email)) {
                _context4.next = 9;
                break;
              }
              return _context4.abrupt("return", true);
            case 9:
              return _context4.abrupt("return", false);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    register: function register() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var localThis, errorMessage, email, encryptedData, billingPlatform, aivitar_id, data, config, response, hasEmailIssue, hasPasswordIssue;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (_this3.showRegisterButton) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              localThis = _this3;
              if (!_this3.isTestingFlow) {
                _context5.next = 8;
                break;
              }
              _this3.$store.commit('startIntroPage', 'QuickMessage');
              _this3.$store.commit('updateNewUserDetected', true);
              _context5.next = 59;
              break;
            case 8:
              _this3.$store.dispatch("registerActionEvent", {
                action: "prelogin",
                data: 'Trying to register'
              });
              errorMessage = '';
              if (_this3.firstname.length < 3) {
                _this3.firstnameError = '* Required';
                errorMessage = 'Please enter a first name';
              } else if (_this3.firstname.length > 25) {
                _this3.firstnameError = '(name is too long)';
                errorMessage = 'Please check first name';
              } else {
                _this3.firstnameError = null;
              }
              _context5.t0 = _this3.email.length < 4;
              if (_context5.t0) {
                _context5.next = 16;
                break;
              }
              _context5.next = 15;
              return _this3.validateEmailFormat();
            case 15:
              _context5.t0 = !_context5.sent;
            case 16:
              if (!_context5.t0) {
                _context5.next = 21;
                break;
              }
              _this3.emailError = '* Required';
              if (errorMessage.length > 0) {
                errorMessage += ', enter valid email address';
              } else {
                errorMessage = 'Please enter a valid email address';
              }
              _context5.next = 22;
              break;
            case 21:
              _this3.emailError = null;
            case 22:
              if (_this3.password.length < 8) {
                _this3.passwordError = '* Required';
                if (errorMessage.length > 0) {
                  errorMessage += ' and a valid password';
                } else {
                  errorMessage = 'Please enter a valid password';
                }
              } else {
                _this3.passwordError = null;
              }
              if (!(errorMessage.length > 0)) {
                _context5.next = 26;
                break;
              }
              _this3.message = errorMessage;
              return _context5.abrupt("return");
            case 26:
              _this3.showLoader = true;
              _this3.message = '';
              email = _this3.email;
              _this3.$store.commit('updateUserEmail', email);
              _context5.next = 32;
              return _this3.encryptDetailsForTransit(_this3.email, _this3.password);
            case 32:
              encryptedData = _context5.sent;
              console.log('intransitEmail', encryptedData.intransitEmail);
              console.log('intransitPassword', encryptedData.intransitPassword);
              billingPlatform = 'web';
              if (process.env.VUE_APP_ANDROID) {
                billingPlatform = 'android';
              }
              localThis.showRegisterButton = false;
              aivitar_id = null;
              try {
                aivitar_id = localStorage.getItem('aivitar_id');
              } catch (error) {
                console.log('error getting aivitar_id', error);
              }
              data = {
                'password': encryptedData.intransitPassword,
                'email': encryptedData.intransitEmail,
                'billingPlatform': billingPlatform,
                'firstname': _this3.firstname,
                'lastname': _this3.lastname,
                'aivitar_id': aivitar_id
                // 'subscriptionType': this.$store.state.subscriptionType
              }; // get current domain with http
              // var domain = window.location.href.split('/').slice(0, 3).join('/');
              config = {
                method: 'post',
                url: "".concat(_this3.$store.state.systemRoute, "/registerAccount"),
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
              };
              _context5.prev = 42;
              _context5.next = 45;
              return axios(config);
            case 45:
              response = _context5.sent;
              console.log('response', response);
              _this3.showLoader = false;
              if (response && response.message) {
                _this3.message = response.message;
              }
              if (response && response.data && response.data.success && response.data.uid) {
                _this3.$store.commit('updateBouncedEmailBlocked', false);
                try {
                  Window.fbq('track', 'Lead');
                } catch (error) {
                  console.log('error in fbq track lead', error);
                }
                _this3.$store.dispatch("registerActionEvent", {
                  action: "prelogin",
                  data: 'registered'
                });
                _this3.$store.commit('updateUserUID', response.data.uid);
                // this.$store.dispatch('crazyEggUserLoggedIn');
                if (response.data.token) {
                  _this3.storeToken(response.data.token);
                  console.log('token should have been stored');
                  _this3.$store.dispatch("registerActionEvent", {
                    action: "prelogin",
                    data: 'token provided'
                  });
                }
                _this3.$store.commit('reEnableHandleAIResponses');

                // this.$store.commit('startIntroPage', 'AppExpectations');
                _this3.$store.commit('startIntroPage', 'QuickMessage');
                _this3.$store.commit('updateNewUserDetected', true);

                // this.$store.commit('updateShowExperienceSelector', true);
                // this.$store.commit("updateShowMainApplication", true);
                // this.$store.commit('updateNewUserDetected', true);
              }
              _context5.next = 59;
              break;
            case 52:
              _context5.prev = 52;
              _context5.t1 = _context5["catch"](42);
              localThis.showRegisterButton = true;
              console.log('error', _context5.t1);
              _this3.$store.dispatch("registerActionEvent", {
                action: "prelogin",
                data: 'login error'
              });
              if (_context5.t1 && _context5.t1.response && _context5.t1.response.data) {
                if (_context5.t1.response.data.message) {
                  _this3.message = _context5.t1.response.data.message;
                } else {
                  _this3.message = 'Please check your details and try again.';
                }
                if (_context5.t1.response.data.errorItems && Array.isArray(_context5.t1.response.data.errorItems)) {
                  hasEmailIssue = false; // let hasFirstnameIssue=false;
                  // let hasLastnameIssue=false;
                  hasPasswordIssue = false;
                  _context5.t1.response.data.errorItems.forEach(function (item) {
                    if (item.issue === 'email') {
                      hasEmailIssue = true;
                      _this3.emailError = '* ' + item.message;
                    }
                    if (item.issue === 'password') {
                      hasPasswordIssue = true;
                      _this3.passwordError = '* ' + item.message;
                    }
                    // if(item.issue === 'firstname'){
                    //     hasFirstnameIssue=true;
                    //     this.firstnameError = '* ' + item.message;
                    // }
                    // if(item.issue === 'lastname'){
                    //     hasLastnameIssue=true;
                    //     this.lastnameError = '* ' + item.message;
                    // }
                  });
                  if (!hasEmailIssue) {
                    _this3.emailError = false;
                  }
                  if (!hasPasswordIssue) {
                    _this3.passwordError = false;
                  }
                  // if(!hasFirstnameIssue){
                  //     this.firstnameError = false;
                  // }
                  // if(!hasLastnameIssue){
                  //     this.lastnameError = false;
                  // }
                }
              }
              _this3.showLoader = false;
            case 59:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[42, 52]]);
      }))();
    }
  },
  setup: function setup() {},
  data: function data() {
    return {
      hasInvalidEmail: false,
      invalidEmail: '',
      showRegisterButton: true,
      isTestingFlow: false,
      introSlides: [{
        image: "assets/web/allavatars.webp",
        topTitle: "Welcome & Thank You!",
        topSummary: "",
        header: "",
        description: "\n          <div style='text-align:left' class='writing'>\n            <div style=\"margin-top: 20px;\"></div>\n            I am so excited you've decided to try this app. \n          \n          <div style=\"margin-top: 10px;\"></div>\n          This has been in development for ..<i>awhile now</i>. I've actually been working on it for <b><i>over 14 months</i></b> working on it day and night...relentlessly.\n          <div style=\"margin-top: 10px;\"></div>\n          I've sacrificed time with my kids, friends and family, holidays and probably even promotions at work.\n          <div style=\"margin-top: 10px;\"></div>\n          I just knew I had to build this and bring it to the masses.\n\n          <div style=\"margin-top: 10px;\"></div>\n          It's not perfect just yet and there is <b><i>SO MUCH MORE coming!</i></b> But I think you'll enjoy it though and we can continue to grow with it together. <div class='yellow'>Running the app is not cheap. Currently this app is costing me over $20k a year to run <i><b>and climbing</b></i> so please support this app where you can or share it with the world.</div> \n          <img style='text-align:left;margin-top:-20px; height:100px;width:auto;position:absolute;right:-10%;z-index:99999;' src='assets/signature.webp' />\n       </div>\n           ",
        imageStyles: {
          height: "auto",
          width: "100%",
          "max-height": "180px",
          "object-fit": "cover"
        }
      }, {
        image: "assets/web/avatarSelector/mary.webp",
        topTitle: "The Goal",
        // topSummary: 'I am so excited you\'ve decided to try this app. This app has been in development for over a year now by a single developer working on this in my spare time.',
        header: "",
        description: "\n          <div style='text-align:left; z-index:10;'>\n            <div style=\"margin-top: 20px;\"></div>\n                  The goal of this app is to make  <b><i>the most realistic digital people imaginable</i></b> and provide a compelling, robust experience that caters to the needs of the user.\n           ",
        // description: 'I\'ve had the ability to talk with AI for a while not but I wanted to build something to bring this to the people.',
        imageStyles: {
          "height": "300px",
          "width": "auto",
          "margin": '0 auto'
        }
      }, {
        image: "assets/web/avatarSelector/kurt.webp",
        topTitle: "Acknowledgement",
        // topSummary: 'I am so excited you\'ve decided to try this app. This app has been in development for over a year now by a single developer working on this in my spare time.',
        header: "",
        description: "\n          <div style='text-align:left; z-index:10;'>\n            <div style=\"margin-top: 20px;\"></div>\n                  While I've gone to great lengths making them as real as possible(still a work in progress though!). <span style=\"color:#a30202\"> Howerver, it's important that you understand that they <b><i>are not real people ...no matter what they tell you.</i></b> \n            </span>\n          <div style=\"margin-top: 20px;\"></div>\n          <div  class=\"yellow\">\n          Please understand that they <b><i>don't have a conscious</i></b>, nor are they <b><i>self aware</i></b> but they may seem really ..<b><i>really real</i></b> when you talk to them.\n          </div> ",
        // description: 'I\'ve had the ability to talk with AI for a while not but I wanted to build something to bring this to the people.',
        imageStyles: {
          "height": "300px",
          "width": "auto",
          "margin": '0 auto'
        },
        nextButtonLabel: "Got it",
        nextButtonIcon: ["fa", "check"]
      }, {
        //     image: "assets/web/avatarSelector/mary.webp",
        //     topTitle: "So many possibilities",
        //     // topSummary: 'I am so excited you\'ve decided to try this app. This app has been in development for over a year now by a single developer working on this in my spare time.',
        //     header: "",
        //     description: `
        //   <div style='text-align:left; z-index:10;'>
        //     <div style="margin-top: 20px;"></div>
        //           Now, we can get onto the fun stuff. Please let us know your feedback on this intro and the app experience in general by joining our discord.
        //     </span>
        //   <div style="margin-top: 20px;"></div>
        //   <b><i>Okay, let's get past the terms and conditions and get started!</i></b>
        //    `,
        //     // description: 'I\'ve had the ability to talk with AI for a while not but I wanted to build something to bring this to the people.',
        //     imageStyles: {
        //       height: "500px",
        //       width: "auto",
        //       "max-height": "350px",

        //       // "object-fit": "cover",
        //     },
        hidePreviousButton: true,
        hideNextButton: true
      }],
      showPassword: false,
      showLoader: false,
      message: '',
      axios: axios,
      showLogin: false,
      showRegistration: true,
      showVerification: false,
      showRedirectToCheckout: false,
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      passwordVerify: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      address1: '',
      address2: '',
      country: '',
      emailError: false,
      passwordError: false,
      firstnameError: false,
      lastnameError: false
    };
  }
};